import { portalRoles } from '../enums/portalRoles';

export const isProfileChild = profile => profile.role === portalRoles.CHILD;
